
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'
import ButtonStrongSquare from '@/components/molecules/ButtonStrongSquare.vue'
import ButtonSubmitSquare from '@/components/molecules/ButtonSubmitSquare.vue'
import ButtonOptionalSquare from '@/components/molecules/ButtonOptionalSquare.vue'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import QuestionInputArea from '@/components/organisms/QuestionInputArea.vue'
import QuestionResultArea from '@/components/organisms/QuestionResultArea.vue'
import ModalCorrectInputText from '@/views/modal/study/ModalCorrectInputText.vue'
import ModalCorrectInputNumericlal from '@/views/modal/study/ModalCorrectInputNumericlal.vue'
import ModalCorrectInputJapanese from '@/views/modal/study/ModalCorrectInputJapanese.vue'
import ModalCorrectInputEnglish from '@/views/modal/study/ModalCorrectInputEnglish.vue'
import ModalProofreadResult from '@/views/modal/proofread/ModalProofreadResult.vue'
import { StudyModel } from '@/models/StudyModel'
import { CurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 校正画面-解答入力画面
 */
@Component({
  components: {
    ImageBase,
    TitlePage,
    ButtonStrongSquare,
    ButtonSubmitSquare,
    ButtonOptionalSquare,
    ManageSidemenuLayout,
    QuestionInputArea,
    QuestionResultArea,
    ModalCorrectInputText,
    ModalCorrectInputNumericlal,
    ModalCorrectInputJapanese,
    ModalCorrectInputEnglish,
    ModalProofreadResult,
  },
})
export default class ProofreadProblemInput extends Vue {
  /** テキスト入力モーダル */
  @Ref()
  modalCorrectInputText!: ModalCorrectInputText

  /** 数式入力モーダル */
  @Ref()
  modalCorrectInputNumericlal!: ModalCorrectInputNumericlal

  /** 日本語入力モーダル */
  @Ref()
  modalCorrectInputJapanese!: ModalCorrectInputJapanese

  /** 英語入力モーダル */
  @Ref()
  modalCorrectInputEnglish!: ModalCorrectInputEnglish

  /** 正誤結果表示モーダル */
  @Ref()
  modalProofreadResult!: ModalProofreadResult

  // TODO: N_LMS-700 API実装後に択一式対応

  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か(未使用) */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** 単元情報 */
  @Prop()
  curriculumUnit!: CurriculumUnit

  /** 小問情報 */
  @Prop()
  problem!: StudyModel.Problem

  /** 正誤判定ボタン押下時の処理 */
  @Prop()
  private eventSubmit!: (question: StudyModel.Question) => Promise<void>

  /** 戻るボタン押下時の処理 */
  @Prop()
  private eventReturn!: () => Promise<void>

  /** トップページボタン押下時の処理 */
  @Prop()
  private eventTopPage!: () => Promise<void>

  /**
   * 正誤結果モーダル表示処理
   *
   * @param question 設問情報
   * @param correctAnswers 正答(入力欄・許容解全ての二次元配列)
   * @param isCorrect 正誤結果
   */
  public showResultModal(question: StudyModel.Question, correctAnswers: string[][], isCorrect: boolean): void {
    this.modalProofreadResult.show(question, correctAnswers, isCorrect)
  }

  /**
   * テキスト入力時のイベント
   *
   * @param question 設問情報
   * @param index 入力欄のインデックス
   * @param afterFunction 入力完了後の処理
   */
  private inputText(question: StudyModel.Question, index: number, afterFunction: StudyModel.AfterInputFunction): void {
    this.modalCorrectInputText.showModal(question, index, afterFunction)
  }

  /**
   * 数式入力時のイベント
   *
   * @param question 設問情報
   * @param index 入力欄のインデックス
   * @param afterFunction 入力完了後の処理
   */
  private inputNumericalFormula(
    question: StudyModel.Question,
    index: number,
    afterFunction: StudyModel.AfterInputNumericalFormulaFunction
  ): void {
    this.modalCorrectInputNumericlal.showModal(question, index, afterFunction)
  }

  /**
   * 日本語手書き入力時のイベント
   *
   * @param question 設問情報
   * @param index 入力欄のインデックス
   * @param afterFunction 入力完了後の処理
   */
  private inputJapanese(
    question: StudyModel.Question,
    index: number,
    afterFunction: StudyModel.AfterInputJapaneseFunction
  ): void {
    this.modalCorrectInputJapanese.showModal(question, index, afterFunction)
  }

  /**
   * 英語手書き入力時のイベント
   *
   * @param question 設問情報
   * @param index 入力欄のインデックス
   * @param afterFunction 入力完了後の処理
   */
  private inputEnglish(
    question: StudyModel.Question,
    index: number,
    afterFunction: StudyModel.AfterInputEnglishFunction
  ): void {
    this.modalCorrectInputEnglish.showModal(question, index, afterFunction)
  }
}
